<template>
  <div class="update-user-pass">
     <TopBackNav class="top-back-nav" Navtitle="修改密码" @backClick="backClick"></TopBackNav>
    <div class="update-item-wrap">
       <div class="update-item-item">
        <span class="item-key">原始密码:</span>
        <input class="item-input" type="password" v-model="oldPwd" />
       </div>
       <div class="update-item-item">
        <span class="item-key">&nbsp;&nbsp;&nbsp;新密码:</span>
        <input class="item-input" type="password" v-model="newPwd" />
       </div>
       <div class="update-item-item">
        <span class="item-key">密码确认:</span>
        <input class="item-input" type="password" v-model="reNewPwd" />
       </div>
    </div>
    <el-button type="primary" class="save-btn" @click="saveClick">保存</el-button>
  </div>
</template>

<script>
import TopBackNav from './TopBackNav'
export default {
  name: 'UpdateUserPass',
  components: {
    TopBackNav
  },
  data () {
    return {
      oldPwd: '',
      newPwd: '',
      reNewPwd: ''
    }
  },
  methods: {
    backClick: function () {
      this.$emit('backClick')
    },
    saveClick: function () {
      if (!this.oldPwd || !this.newPwd || !this.reNewPwd) {
        this.$message.error('输入不能为空')
        return
      }
      if (this.newPwd !== this.reNewPwd) {
        this.$message.error('两次密码不一致')
        return
      }
      if (!this.checkPassValid(this.newPwd)) return
      let data = {
        old_passwd: this.oldPwd,
        new_passwd: this.newPwd
      }
      this.$api.liveServer.updatePasswd(data).then(res => {
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.$emit('backClick')
        } else {
          this.$message.error('修改失败 #' + res.code)
        }
      })
    },
    checkPassValid: function (pass) {
      var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,16}')
      if (!pwdRegex.test(pass)) {
        this.$message.error('您的密码复杂度太低（密码中必须包含字母、数字），请修改密码！');
        return false
      }
      return true
    }
  }
}
</script>

<style>

  .top-back-nav{
    margin: 10;
  }
  .update-user-pass{
  }

  .update-item-item{
    margin-bottom: 20px;
    height: 30px;
    margin-top: 20px;
    margin-left: 30px;

    color: #4A4A4A;
    font-size: 15px;
  }

  .item-input{
    border: 1px solid #cccccc;
    border-radius: 4px;
    padding: 5px;
    margin-left: 15px;
  }

  .save-btn{
    margin-left: 120px;
    margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/userinfo/UpdateUserPass.vue